import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://api.boltin.com';
const B2B_INVOICES_API_PATH = '/api/b2b-invoices';

const fetchInvoices = async (params = {}) => {
  const response = await axios.get(`${API_BASE_URL}${B2B_INVOICES_API_PATH}`, { params });
  return response.data;
};

const getInvoice = async (id) => {
  const response = await axios.get(`${API_BASE_URL}${B2B_INVOICES_API_PATH}/${id}`);
  return response.data.data;
};

const recordPayment = async (id, payload) => {
  const response = await axios.post(`${API_BASE_URL}${B2B_INVOICES_API_PATH}/${id}/payments`, payload);
  return response.data.data;
};

const createCreditNote = async (id, payload) => {
  const response = await axios.post(`${API_BASE_URL}${B2B_INVOICES_API_PATH}/${id}/credits`, payload);
  return response.data.data;
};

const recordRefund = async (id, payload) => {
  const response = await axios.post(`${API_BASE_URL}${B2B_INVOICES_API_PATH}/${id}/refunds`, payload);
  return response.data.data;
};

const generatePdf = async (id) => {
  const response = await axios.post(`${API_BASE_URL}${B2B_INVOICES_API_PATH}/${id}/pdf`, {}, {
    responseType: 'blob',
  });
  return response.data;
};

const b2bInvoiceService = {
  fetchInvoices,
  getInvoice,
  recordPayment,
  createCreditNote,
  recordRefund,
  generatePdf,
};

export default b2bInvoiceService;
